import client from "../client/client";

class DistributionListService {
	getTerritoriesWithDistribution({ buName, page, limit, sort, direction }, cancelToken) {
		return client.get("/distribution/lists", {
			params: { buName, page, limit, sort, direction },
			config: { cancelToken },
		});
	}

	createOrUpdate({ territoryId, email }, cancelToken) {
		return client.post("/distribution/lists", {
			payload: { territoryId, email },
			config: { cancelToken },
		});
	}

	deleteByTerritoryId(territoryId, cancelToken) {
		return client.delete(`/distribution/lists/territory/${territoryId}`, {
			config: { cancelToken },
		});
	}
}

export default new DistributionListService();
